import axiosClient from "./axiosClient";

// Fetch user profile
export const getUserProfile = async () => {
  try {
    const response = await axiosClient.get("/user/me");
    return response.data;
  } catch (error) {
    throw error;
  }
};
